<ng-container>
    <div class="modal-content">

        <!-- Header -->
        <div class="header">
            <span class="title">
                Write your email with
            </span>
            <img class="vector-icon" src="images/Vector.svg">
            <span class="loading">AIden</span>
            <!-- <span *ngIf="aiLoad || contentBody != ''" class="email-pointer float-right footer-left" (click)="closePanel()">
                <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
            </span> -->
        </div>

        <!-- Body -->
        <div class="body">
            <div class="flex-display">
                <img *ngIf="!aiLoad && contentBody == ''" src="images/Group.svg" alt="Avatar"
                            class="icon">
                <img *ngIf="aiLoad || contentBody != ''" src="images/Vector.svg">
                <!-- <div class="text-width"></div> -->
                <textarea class="prompt-input" [(ngModel)]="promptText" #promptInput placeholder="Type your prompt here"> </textarea>
            </div>

            <div *ngIf="aiLoad" class="loading-page">
                <div class="small-bar"></div>
                <div class="gap"></div>
                <div class="large-bar"></div>
                <div class="gap"></div>
                <div class="large-bar"></div>
                <div class="gap"></div>
                <div class="small-bar"></div>
            </div>
            <div *ngIf="!aiLoad && contentBody != ''" class="mail-content" [innerHTML]="contentBody">

            </div>

        </div>

        <!-- Footer -->
        <div class="template-footer" [ngStyle]="{bottom: (contentBody === '' && aiLoad === true) || contentBody !== '' ? '6px' : '-24px'}">
            <div *ngIf="contentBody != ''" class="float-left footer-left">
              <!-- Recreate -->
              <a #rewriteDropdown class="cancel-button pointer-cursor pl-6" (click)="toggleDropdown('rewrite')" translate>
                <i class="fa-regular fa-arrow-rotate-right"></i> Recreate
              </a>

              <!-- Rewrite Options Dropdown -->
              <div class="recreate-dropdown-box" *ngIf="showRewriteOptions" (click)="$event.stopPropagation()">
                <span class="font-bold">Recreate</span>
                <label *ngFor="let opt of rewriteOptions">
                  <input style="margin-bottom:5px" type="checkbox" [(ngModel)]="opt.checked"> <span style="padding-left: 8px">{{ opt.label }}</span>
                </label>
                <button class="btn btn-primary float-right" [disabled]="!hasCheckedRewriteOptions()" (click)="applyOptions('rewrite')">Apply</button>
              </div>

              <!-- Adjust Tone -->
              <a #toneDropdown class="cancel-button pointer-cursor" (click)="toggleDropdown('tone')" translate>
                <i class="fa-solid fa-microphone"></i> Adjust tone
              </a>

              <!-- Tone Options Dropdown -->
              <div class="tone-dropdown-box" *ngIf="showToneOptions" (click)="$event.stopPropagation()">
                <span class="font-bold">Adjust Tone</span>
                <label *ngFor="let opt of toneOptions">
                  <input style="margin-bottom:5px" type="checkbox" [(ngModel)]="opt.checked"> <span style="padding-left: 8px">{{ opt.label }}</span>
                </label>
                <button class="btn btn-primary float-right" [disabled]="!hasCheckedToneOptions()" (click)="applyOptions('tone')">Apply</button>
              </div>
            </div>

            <div *ngIf="!aiLoad" class="float-right">
              <a class="cancel-button pointer-cursor padding-right" id="aiden-modal-cancel-button" (click)="closePanel()" translate>Cancel</a>
              <button *ngIf="contentBody == ''" [disabled]="promptText == ''" class="btn model-generate pointer-cursor btn-generate" (click)="generatePrompt()">
                <span class="btn-text">Generate</span>
              </button>
              <button *ngIf="contentBody != ''" class="btn model-generate pointer-cursor btn-insert" (click)="insertMail()">
                <span class="btn-text">Insert</span>
              </button>
            </div>

            <div *ngIf="aiLoad" class="float-right">
              <div class="spinner-icon padding-right"></div>
              <span style="padding-left:10px" class="loading padding-right">AI is writing</span>
              <button class="btn model-generate" (click)="stopLoad()">
                <span class="btn-text" translate>Stop</span>
              </button>
            </div>
          </div>

    </div>
</ng-container>
